if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.slideshow = this.querySelector('slideshow-component:not(.slider--collapse)');
        this.thumbnailGallery = this.querySelector('thumbnail-gallery');
        this.activeMedia = this.dataset.activeMedia;
        this.initLazySlides();

        if (this.slideshow && this.activeMedia) {
          const mediaSlide = this.querySelector(`[data-media-id="${this.activeMedia}"]`);
          setTimeout(() => this.slideshow.jumpToSlide(mediaSlide, true), 0);
        }

        document.addEventListener('variant:change', (event) => {
          if (event.detail.sectionId === this.dataset.section) {
            if (event.detail.variant.featured_media) {
              this.changeImage(event.detail.variant.featured_media.id);
            }
          }
        });

        let stickyMedia = this.querySelector('.pdp-thumbnails');
        if (this.dataset.style == 'scroll') stickyMedia = this;
        if (!stickyMedia) return;
        this.observer = new ResizeObserver((entries) => {
          if (!window.matchMedia('(min-width:48em)').matches) return;
          const style = getComputedStyle(this);
          const stickyHeight = parseFloat(style.getPropertyValue('--sticky-header-height').replace('px', ''));
          const transparentHeight = parseFloat(style.getPropertyValue('--transparent-header-height').replace('px', ''));
          if (window.innerHeight - stickyHeight + transparentHeight >= stickyMedia.clientHeight - 10) {
            this.classList.add('media-gallery--sticky');
          } else {
            this.classList.remove('media-gallery--sticky');
          }
        });
        this.observer.observe(document.documentElement);
      }

      /* Aventus 3.9 (speed): gallery photos other than the first carry their image in data-srcset/data-src
         (see product-media.liquid). They load once the shopper starts using the gallery (swipe, arrows, flavour
         change) or shortly after the page has finished loading, and then only the slides next to the one on
         screen. On desktop the photos are stacked, so they load as they come near the viewport. */
      initLazySlides() {
        const imgs = Array.from(this.querySelectorAll('img.av-lazy'));
        if (!imgs.length) return;
        const load = (img) => {
          if (!img.classList.contains('av-lazy')) return;
          if (img.dataset.srcset) img.srcset = img.dataset.srcset;
          if (img.dataset.src) img.src = img.dataset.src;
          img.removeAttribute('data-srcset');
          img.removeAttribute('data-src');
          img.classList.remove('av-lazy');
        };
        if (!('IntersectionObserver' in window)) {
          imgs.forEach(load);
          return;
        }
        const slider = this.querySelector('.slider--generic');
        let started = false;
        const start = () => {
          if (started) return;
          started = true;
          const horizontal = slider && slider.scrollWidth > slider.clientWidth + 5;
          const observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (!entry.isIntersecting) return;
                load(entry.target);
                observer.unobserve(entry.target);
              });
            },
            horizontal ? { root: slider, rootMargin: '0px 100% 0px 100%' } : { rootMargin: '400px 0px' }
          );
          this.querySelectorAll('img.av-lazy').forEach((img) => observer.observe(img));
        };
        ['pointerdown', 'touchstart', 'keydown', 'click'].forEach((type) =>
          this.addEventListener(type, start, { once: true, passive: true })
        );
        if (slider) slider.addEventListener('scroll', start, { once: true, passive: true });
        document.addEventListener('variant:change', start, { once: true });
        if (window.matchMedia('(min-width: 48em)').matches) {
          start();
        } else if (document.readyState === 'complete') {
          setTimeout(start, 1000);
        } else {
          window.addEventListener('load', () => setTimeout(start, 500), { once: true });
        }
      }

      changeImage(id) {
        if (!id) return;
        if (this.slideshow) {
          const slide = this.slideshow.querySelector(`[data-media-id="${id}"]`);
          this.slideshow.jumpToSlide(slide);
        } else if (this.thumbnailGallery) {
          this.thumbnailGallery.activateMedia(id.toString());
        }
        if (this.dataset.style === 'scroll' && window.matchMedia('(min-width:48em)').matches) {
          const image = this.querySelector(`[data-media-id="${id}"]`);
          image.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    }
  );
}
